import { render, staticRenderFns } from "./NewBulletinModal.vue?vue&type=template&id=f2e50cf6&"
import script from "./NewBulletinModal.vue?vue&type=script&lang=js&"
export * from "./NewBulletinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports